import React from 'react';
import './PhoneLink.css';

/** Build tel: href from a display string (E.164-style preferred). */
export function phoneToTelHref(phone) {
  if (phone == null || phone === '') return null;
  const raw = String(phone).trim();
  if (!raw || raw === '—') return null;
  const compact = raw.replace(/\s/g, '').replace(/[()]/g, '');
  if (compact.startsWith('+')) {
    return `tel:${encodeURIComponent(compact)}`;
  }
  const digits = compact.replace(/\D/g, '');
  if (digits.length < 7) return null;
  return `tel:+${digits}`;
}

/**
 * Renders a phone number as a callable link when possible; otherwise plain text.
 */
export function PhoneLink({ phone, className = '' }) {
  if (phone == null || phone === '' || phone === '—') {
    return <span className={className}>—</span>;
  }
  const href = phoneToTelHref(phone);
  if (!href) {
    return <span className={`lux-phone-text ${className}`.trim()}>{phone}</span>;
  }
  return (
    <a href={href} className={`lux-phone-link ${className}`.trim()}>
      {phone}
    </a>
  );
}
